<template>
    <!-- Footer start -->
    <div class="bg-stone-700 w-full flex flex-row justify-evenly gap-8 p-8">
        <!-- Overview start -->
        <div class="flex flex-col md:flex-row md:justify-evenly items-center text-center md:text-left space-y-2 md:space-y-0">
					<p class="font-light text-stone-100">TRIPLE PALM REHAB CENTRE</p>
					<p class="font-light text-stone-100 md:ml-5">Phone: +254723168719</p>
					<p class="font-light text-stone-100 md:ml-5">Location: Tuinuane Phase 1, Nakuru</p>
					<p class="font-light text-stone-100 md:ml-5">P.O. Box: 719-20100, Nakuru - Kenya</p>
			</div>
        <!-- Overview end -->

        <!-- Links start -->
        <!-- <div class="text-stone-100 flex justify-center items-center gap-8">
			<a href="#">
				<i class="fa-brands fa-instagram socialIcon"></i>
			</a>
			<a href="#">
				<i class="fa-brands fa-linkedin socialIcon"></i>
			</a>
			<a href="#">
				<i class="fa-brands fa-facebook socialIcon"></i>
			</a>
			
			<a href="#">
				<i class="fa-brands fa-pinterest socialIcon"></i>
			</a>
        </div> -->
        <!-- Links end -->
    </div>
    <!-- Footer end -->
</template>

<script>
export default {

}
</script>

<style>

</style>